import { Component, OnInit,Inject } from '@angular/core';
import { FormControl, FormGroup, FormBuilder, Validators, FormArray, ValidatorFn } from '@angular/forms';
import { GroupService } from '../../services/group/group.service';
import { CommonService } from '../../services/common/common.service';
import { DashboardService } from "../../services/dashboard/dashboard.service";
import { MatDialog, MAT_DIALOG_DATA, MatDialogRef } from "@angular/material";
import { UserService } from "../../services/user/user.service";

@Component({
    selector: 'export-mail',
    templateUrl: './export-mail.component.html',
    styleUrls: ['./export-mail.component.scss']
})
export class ExportMailComponent implements OnInit {
    openMail: boolean = false;
    exportMailForm: FormGroup;
    dashboardName;
    groupIds;
    dashboardId;
    enumexportDType = [
        { id: "pdf", value: "PDF"},
        { id: "excel", value: "Excel" },
        { id: "csv", value: "CSV"},
    ];
    exportDType = [];
    userExportPer;
    exdTopOffset= 0
    constructor(
        public dialog: MatDialog,
        private groupService: GroupService,
        public fb: FormBuilder,
        private userService: UserService,
        private commonService: CommonService,
        private dashboardService: DashboardService
    ) {

        this.groupService.getAction().subscribe(res => {
            if (['openMail'].includes(res.action)) {
                this.openMail = true;
                this.dashboardName = res.data.dashboardName;
                this.dashboardId = res.data.dashboardId;
                this.groupIds = res.data.groupIds;
                this.updateForm();
                $('.group-filter').hide();        
                let topOffset =  $('#'+this.groupIds).offset().top;
                topOffset = topOffset - 130;
                this.exdTopOffset = parseInt(topOffset.toString());
                $('.group-filter').show();
            }
        });

        let userP = this.userService.getLoggedInUser();
        this.userExportPer = userP.settings;
        this.userPermiExport();
    }

    ngOnInit() {
        this.createForm();
    }
    userPermiExport() {
        if (this.userExportPer.excel == "0")
            this.exportDType.push(this.enumexportDType.find((o) => o.id == "excel"));

        if (this.userExportPer.pdf == "0")
            this.exportDType.push(this.enumexportDType.find((o) => o.id == "pdf"));

        if (this.userExportPer.csv == "0")
            this.exportDType.push(this.enumexportDType.find((o) => o.id == "csv"));

    }

    createForm() {
        const exportControls = this.exportDType.map((c) => {  new FormControl(false) });

        this.exportMailForm = this.fb.group({
            groupIds:[''],
            dashboardId:[''],
            to: ['', Validators.required],
            cc: [''],
            bcc: [''],
            subject: [this.dashboardName],
            reportName: [this.dashboardName],
            message: ["This is the " + this.dashboardName],
            dateFormat: ['YYYY-MM-D'],
            exportType: this.fb.array(exportControls, minSelectedCheckboxes(1))
        });
    }

    updateForm() {
        this.exportMailForm.patchValue({
            subject: this.dashboardName,
            reportName: this.dashboardName,
            message: "This is the " + this.dashboardName,
            groupIds:this.groupIds,
            dashboardId:this.dashboardId
        });
        this.exportMailForm.get('to').reset();
        this.exportMailForm.get('exportType').reset();
        
    }

    dailyHeadersVal() {
        let selectedHeaders = this.exportMailForm.value.exportType
            .map((v, i) => v ? this.exportDType[i].id : null)//this.dailyA[i].id : null)
            .filter(v => v !== null);
        return selectedHeaders;

    }

    getExportMailType(){
        return <FormArray>this.exportMailForm.controls['exportType'];
    }


    onSubmit() {
        if (this.exportMailForm.valid) { 
            let formData={
                groupIds:this.exportMailForm.get('groupIds').value,
                dashboardId:this.exportMailForm.get('dashboardId').value,
                to: this.exportMailForm.get('to').value,
                cc:this.exportMailForm.get('cc').value,
                bcc:this.exportMailForm.get('bcc').value,
                subject: this.exportMailForm.get('subject').value,
                reportName:this.exportMailForm.get('reportName').value,
                message: this.exportMailForm.get('message').value,
                dateFormat: this.exportMailForm.get('dateFormat').value,
                exportType: this.dailyHeadersVal()
            }
            this.dashboardService.requestMail("export/dashboardmail", formData).subscribe((res) => {
                this.commonService.openSnackBar("We are processing your request will be mailing you shortly", "");
                this.openMail = false;
            }, (err) => {
                console.log(err);
                this.commonService.openSnackBar("Failed while mailing", "");
                this.openMail = false;
            });
        }
    }

    getFormatDate(){
    this.dialog.open(DateFormatDialog, {
        data: {},
        height: "auto",
        width: "600px",
        panelClass: "full-modal"
      });
    }

    closeFilter() {
        this.openMail = false;
    }

}

function minSelectedCheckboxes(min = 1) {
    const validator: ValidatorFn = (formArray: FormArray) => {
        const totalSelected = formArray.controls
            // get a list of checkbox values (boolean)
            .map(control => control.value)
            // total up the number of checked checkboxes
            .reduce((prev, next) => next ? prev + next : prev, 0);

        // if the total is not greater than the minimum, return the error message
        return totalSelected >= min ? null : { required: true };
    };

    return validator;
}
@Component({
    selector: "date-format",
    templateUrl: "date-format.dialog.html"
  })
  export class DateFormatDialog {
    
    constructor(
      @Inject(MAT_DIALOG_DATA) public data: any,
      public dialogRef: MatDialogRef<DateFormatDialog>
    ) {}

  }
  


// WEBPACK FOOTER //
// D:/Xpand-Dubai/xpand_retail_int/Customers/app/src/app/shared/export/export-mail/export-mail.component.ts